<section class="business-stories">
  <h2>Real businesses, <span class="accent">real results</span></h2>

  <div class="story-showcase">
    <button type="button" class="story-nav story-nav-prev" (click)="prev()" aria-label="Previous story">
      <i class="fas fa-chevron-left"></i>
    </button>

    <article class="story-feature" [style.--story-color]="stories[activeIndex].color">
      <span class="story-feature-quote" aria-hidden="true">&#8220;</span>
      <p class="story-feature-text">{{ stories[activeIndex].text }}</p>

      <div class="story-feature-author">
        <img [src]="stories[activeIndex].image" alt="" />
        <div>
          <h4>{{ stories[activeIndex].name }}</h4>
          <span>{{ stories[activeIndex].role }}</span>
        </div>
      </div>
    </article>

    <button type="button" class="story-nav story-nav-next" (click)="next()" aria-label="Next story">
      <i class="fas fa-chevron-right"></i>
    </button>
  </div>

  <div class="story-dots">
    <button
      type="button"
      class="story-dot"
      *ngFor="let story of stories; let i = index"
      [class.story-dot-active]="i === activeIndex"
      [style.--story-color]="story.color"
      (click)="select(i)"
      [attr.aria-label]="'Show story ' + (i + 1)"
    ></button>
  </div>
</section>
